<top-banner variant="title" title="Site Forms"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">

        <div class="row animated fadeIn">
          <!-- side menu -->
          <div class="col-md-2 cardtabs-wrapper">
            <nav class="nav cardtabs flex-column"><!-- todo: fix css class -->
              <div class="back-and-menu-link">
                <a [routerLink]="['/', routeRole, 'site-forms']" class="nav-link back-link">back to all forms</a>
              </div>
                <a [routerLink]="['/', routeRole, 'site-forms', siteFormId, 'update']" class="btn btn-primary btn-link" style="text-align: left;padding: 5px 0; margin: 0;">edit form</a>
                <button type="button" class="btn btn-danger btn-link" style="text-align: left;padding: 5px 0; margin: 0;" (click)="deleteForm()">delete form</button>
            </nav>
          </div>

          <!-- main area -->
          <div class="col-md-10 mb-2" *ngIf="!this.isLoading">
            <h4 class="card-title">{{ siteForm.name }}</h4>

            <!-- form details -->
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex flex-column gap">

                <dl class="sideways-dl">
                  <div>
                    <dt>Site Owner</dt>
                    <dd> {{siteForm.siteOwnerName}} </dd>
                  </div>
                  <div>
                    <dt>Created Date</dt>
                    <dd> <date-friendly [value]="siteForm.createdDate"></date-friendly> </dd>
                  </div>
                  <div>
                    <dt>Last Updated</dt>
                    <dd> <date-friendly [value]="siteForm.lastModifiedDate"></date-friendly> </dd>
                  </div>
                  <div>
                    <dt>Version</dt>
                    <dd>{{ siteForm.version }}</dd>
                  </div>
                </dl>

                <div>
                  <h6>Linked Sites</h6>
                  <div *ngFor="let site of siteForm.linkedSites">
                    <label>{{site.siteName}}</label>
                  </div>
                  <button class="btn btn-primary btn-sm work-order-button" (click)="editLinkedSites()">Edit linked sites</button>
                </div>
              </div>

              <!-- Preview box -->
              <site-forms-preview [formFields]="siteForm.data"></site-forms-preview>
            </div>

            <br>
            <br>
            <br>
            <br>

            <!-- Table area -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-row">
                  <div class="col-md-9">
                    <h6>Responses</h6>
                  </div>
                  <div class="col-md-3">
                    <button type="button" (click)="columnOptionsSidebarVisible = true" class="btn btn-round btn-primary btn-sm float-right">toggle columns</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12" style="margin-left: -12px;">
                    <site-form-responses-table [siteFormId]="siteForm.id" [tableOptions]="tableOptions"></site-form-responses-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
